import cl from 'classnames';
import { some } from 'lodash';
import * as React from 'react';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

import { someNode } from '../../../../slatePlugins/common/queries/someNode';
import { getPreventDefaultHandler } from '../../../../slatePlugins/common/utils/getPreventDefaultHandler';
import { ToolbarButtonProps } from '../../../../slatePlugins/components/ToolbarButton/ToolbarButton.types';
import { ToolbarElement } from '../../../../slatePlugins/components/ToolbarElement/ToolbarElement';
import { ToolbarElementProps } from '../../../../slatePlugins/components/ToolbarElement/ToolbarElement.types';
import { ToolbarMark } from '../../../../slatePlugins/components/ToolbarMark/ToolbarMark';
import { ToolbarMarkProps } from '../../../../slatePlugins/components/ToolbarMark/ToolbarMark.types';
import { ToolbarList } from '../../../../slatePlugins/elements/list/components/ToolbarList';
import { isElementWithType } from '../../helpers/node-filter';
import { SideToolbarItemStyle } from '../sidebar/SideToolbarItemStyle';

const StyledToolbarElement = styled(ToolbarElement)`
  ${SideToolbarItemStyle}
`;

const StyledToolbarMark = styled(ToolbarMark)`
  ${SideToolbarItemStyle}
`;

const StyledToolbarList = styled(ToolbarList)`
  ${SideToolbarItemStyle}
`;

type WrappedComponentProps = ToolbarElementProps | ToolbarMarkProps | ToolbarButtonProps;

interface DisableCondition {
  onActiveElementType?: string[];
}

interface DisableToolbarItemProps {
  disable?: DisableCondition;
}

export const withDisableToolbarItem =
  (WrappedComponent) =>
  ({ disable, ...rest }: WrappedComponentProps & DisableToolbarItemProps) => {
    // check if has disable policy
    const editor = useSlate();
    let newClassName = (rest as any).className;
    if (
      disable?.onActiveElementType &&
      some(disable.onActiveElementType, (type) =>
        someNode(editor, { match: (node: any) => isElementWithType(node, type) })
      )
    ) {
      newClassName = cl(newClassName, 'toolbar-item-disabled');
      (rest as any).onMouseDown = getPreventDefaultHandler(); // disable toggle item
    }
    return <WrappedComponent className={newClassName} {...rest} />;
  };

export const disable = {
  ToolbarElement: withDisableToolbarItem(StyledToolbarElement),
  ToolbarMark: withDisableToolbarItem(StyledToolbarMark),
  //
  ToolbarList: withDisableToolbarItem(StyledToolbarList),
};
